import React, { useEffect, useRef } from 'react';

const QuoteBanner = () => {
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100', 'translate-y-0');
          entry.target.classList.remove('opacity-0', 'translate-y-7');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    if (elementRef.current) observer.observe(elementRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section 
      className="relative py-32 bg-cover bg-center md:bg-fixed font-sans"
      style={{ backgroundImage: `url('https://img.magnific.com/free-photo/electrical-panel-with-fuses-contactors-closeup_169016-52159.jpg?semt=ais_hybrid&w=740&q=80')` }}
    >
      {/* Diagonal Dark Overlay from cogBlue to cogBrand */}
      <div className="absolute inset-0 bg-gradient-to-br from-cogBlue/90 via-cogBrand/70 to-cogBrand/40"></div>
      
      {/* Quote Block Container integrating your custom shadow-glow utility */}
      <div 
        ref={elementRef}
        className="relative max-w-4xl mx-auto px-8 py-12 text-center opacity-0 translate-y-7 transition-all duration-700 ease-out   "
      >
        <svg className="mx-auto mb-6 text-cogAccentBlue" width="40" height="32" viewBox="0 0 40 32" fill="currentColor">
          <path d="M0 20C0 8 8 0 18 0v6c-6 0-10 5-10 10h10v14H0V20zm22 0C22 8 30 0 40 0v6c-6 0-10 5-10 10h10v14H22V20z" />
        </svg>
       <p className="font-display text-2xl sm:text-3xl text-cogLight leading-snug font-medium">
  "From concept to connection, every solution we create is driven by precision engineering, uncompromising quality, and a commitment to building partnerships that last."
</p>

<p className="mt-6 text-cogLight/70 text-sm uppercase tracking-widest font-semibold">
  — PVS Harness Solutions
</p>
      </div>
    </section>
  );
};

export default QuoteBanner;